import { render, staticRenderFns } from "./workOrderPageUser.vue?vue&type=template&id=1f8352e1&scoped=true"
import script from "./workOrderPageUser.vue?vue&type=script&lang=js"
export * from "./workOrderPageUser.vue?vue&type=script&lang=js"
import style0 from "./workOrderPageUser.vue?vue&type=style&index=0&id=1f8352e1&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8352e1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f8352e1')) {
      api.createRecord('1f8352e1', component.options)
    } else {
      api.reload('1f8352e1', component.options)
    }
    module.hot.accept("./workOrderPageUser.vue?vue&type=template&id=1f8352e1&scoped=true", function () {
      api.rerender('1f8352e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/workorder/components/workOrderPageUser.vue"
export default component.exports